import {Dispatch, SetStateAction} from 'react';

export type BaseFilters = {
	offset: number | '';
};

const useClickMoreButton = <T extends BaseFilters>(
	setFilters: Dispatch<SetStateAction<T>>,
) => {
	const handleClickMoreButton = () => {
		setFilters(
			(prev) =>
				({
					...prev,
					offset: typeof prev.offset === 'number' ? prev.offset + 10 : 10,
				}) as T,
		);
	};

	return {
		handleClickMoreButton,
	};
};

export default useClickMoreButton;
